import {Col, Form, Input, Row, Space, Table} from "antd"
import React, {useEffect, useState} from "react"
import {useSelector} from "react-redux"
import Column from "antd/es/table/Column"
import {debounceTime, distinctUntilChanged} from "rxjs/operators"
import {Subject} from "rxjs"
import {fetchCompetitors} from "../../service/competitor.service"
import {ICompetitor} from "../../model/competitor.model"
import {RootState} from "../../common/store"
import {EditCompetitorModal} from "./edit-competitor.modal"

interface CompetitorsPageFilters {
    readonly search?: string
}

const CompetitorsPage = () => {
    const [competitors, setCompetitors] = useState([] as ReadonlyArray<ICompetitor>)
    const [loading, setLoading] = useState(false)
    const [filters, setFilters] = useState({} as CompetitorsPageFilters)
    const [currentCompetitorId, setCurrentCompetitorId] = useState<number | undefined>(undefined)

    const [form] = Form.useForm()

    const school = useSelector((state: RootState) => state.school)

    const [onSearch$] = useState(() => new Subject())

    useEffect(() => {
        const subscription = onSearch$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
        ).subscribe((value) => setFilters({search: value as string}))

        return () => subscription.unsubscribe()
    }, [])

    useEffect(() => {
        initData()
    }, [filters.search])

    const onSearchChange = (event: any) => onSearch$.next(event.target.value)

    const editCompetitor = (value: number): void => {
        setCurrentCompetitorId(value)
    }

    const onEndEditCompetitor = (): void => {
        setCurrentCompetitorId(undefined)
        initData()
    }

    const initData = (): void => {
        setLoading(true)

        fetchCompetitors(school.id!, filters.search).subscribe(value => {
            setCompetitors(value)
            setLoading(false)
        })
    }

    return (
        <>
            <div style={{display: "flex", flexDirection: "column"}}>
                <h1 style={{textAlign: "center", fontSize: "30px"}}>COMPETITORI</h1>
                <Form
                    form={form}
                    layout="vertical"
                    size="middle"
                    name="filtersForm"
                >
                    <Row gutter={100} justify="space-between">
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="Ricerca"
                                key={"search"}
                                name="search"
                            >
                                <Input placeholder="Cerca per nome, cognome o codice fiscale" type={"text"}
                                       onChange={(value) => onSearchChange(value)}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Table
                    id="subscriptionsTable"
                    scroll={{x: "max-content"}}
                    dataSource={competitors}
                    loading={loading}
                    rowKey={(record) => record.id + ' ' + Math.random()}
                    pagination={{position: ['bottomCenter']}}>
                    <Column title="Codice Fiscale" dataIndex="fiscalCode" key="fiscalCode"/>
                    <Column title="Cognome" dataIndex="surname" key="surname"/>
                    <Column title="Nome" dataIndex="name" key="name"/>
                    <Column
                        key="action"
                        align={"end"}
                        render={(value) => (
                            <Space size="middle">
                                <a onClick={() => editCompetitor(value.id)}>Modifica</a>
                            </Space>
                        )}
                    />
                </Table>
            </div>
            {currentCompetitorId && <EditCompetitorModal
                competitorId={currentCompetitorId}
                close={onEndEditCompetitor}
                isOpen={!!currentCompetitorId}
            />
            }
        </>
    )
}

export default CompetitorsPage